import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var MoveGravity = /*#__PURE__*/function () {
  function MoveGravity() {
    _classCallCheck(this, MoveGravity);
    this.acceleration = 9.81;
    this.enable = false;
    this.inverse = false;
    this.maxSpeed = 50;
  }
  _createClass(MoveGravity, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.acceleration !== undefined) {
        this.acceleration = setRangeValue(data.acceleration);
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.inverse !== undefined) {
        this.inverse = data.inverse;
      }
      if (data.maxSpeed !== undefined) {
        this.maxSpeed = setRangeValue(data.maxSpeed);
      }
    }
  }]);
  return MoveGravity;
}();